const SvgComponent = (props) => (
  <svg
    width={12}
    height={20}
    viewBox="0 0 12 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.681 3.767c2.126 0 3.315.925 3.315.925L12 .712l-.055-.02C10.617.228 9.068 0 7.933 0 3.422-.005 2.747 3.257 2.745 5.202l-.003 2.007-2.74-.003L0 10.486l2.74.004-.002 2.322H.003v3.295h2.732l-.002 3.888L6.858 20l.003-3.893h4.31l.819-3.295H6.863l.002-2.316 4.306.005.822-3.28-5.126-.006.003-1.398c0-.915-.013-2.05 1.811-2.05Z"
      fill="currentColor"
    />
  </svg>
)

export default SvgComponent
